import React, { useEffect } from 'react';
import {Navigate} from 'react-router-dom';
import { useSelectedFranchisee } from '../context/SelectedFranchiseeContext';

const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');

  if(!token) return { isAuthenticated: false };
  
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1])); 
    const currentTime = Date.now() / 1000; 

    if(decodedToken.exp < currentTime){
      console.warn('Token has expired. Please request a new magic link.');
      return { isAuthenticated: false };
    }
    return { isAuthenticated: true, role: decodedToken.role };
  } catch (error) {
    console.error('Error decoding token:', error);
    return { isAuthenticated: false };
  }
}

const ProtectedRoute = ({element: Component,requiredRole, ...rest}) => {
  const { isAuthenticated: auth, role} = isAuthenticated();
  const { clearSelectedFranchisee } = useSelectedFranchisee();

  // Clean up any remaining token if it's expired
  useEffect(() => {
    if (!auth && localStorage.getItem('authToken')) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('viewedPages');
      localStorage.removeItem('selectedClient');
      localStorage.removeItem('selectedFranchisee');
      clearSelectedFranchisee();
    }
  }, [auth]);

  if(!auth){
    return <Navigate to="/magic-link-request" replace />
  }

  if(requiredRole && role !== requiredRole ){
    return <Navigate to="/" replace />;
  }

  return <Component {...rest} />;
  }

  export default ProtectedRoute;

